import type { AnalyticsEvent } from '~/modules/services/analyticsService';
import type { ReviewUpdateResult } from '~/modules/stores/reviewStore';
import { handleException } from '~/modules/utilities/error_utilities';

export type ReviewSearchAnalyticsEvent = AnalyticsEvent & {
    reviewAction?: 'filter' | 'sort';
    reviewUpdate?: Promise<ReviewUpdateResult>;
    reviewResultCount?: number;
};

// Let the original click bubble immediately, while its component and listing
// context are still mounted. The persistent analytics handler owns the wait.
export function addReviewSearchAnalyticsContext(
    event: CustomEvent,
    action: 'filter' | 'sort',
    update: Promise<ReviewUpdateResult> | undefined,
): void {
    if (!['filter', 'chip'].includes(event.detail.elementType)) {
        return;
    }
    event.detail.reviewAction = action;
    event.detail.reviewUpdate = update;
}

export async function forwardReviewSearchAnalytics(
    event: ReviewSearchAnalyticsEvent,
    dispatch: (event: AnalyticsEvent) => void | Promise<void>,
): Promise<void> {
    const { reviewUpdate, reviewResultCount: _previousCount, ...detail } = event;
    let result: ReviewUpdateResult | undefined;
    try {
        result = await reviewUpdate;
    } catch (error) {
        handleException(error, 'reviewAnalytics.forwardReviewSearchAnalytics');
        result = { isSuccess: false };
    }
    await dispatch({
        ...detail,
        ...(result?.isSuccess ? { reviewResultCount: result.resultCount } : {}),
    });
}
